import { Routes } from '@angular/router';
import { themeResolver } from '../utils/app.resolver';
import { HomeComponent } from './home/home.component';
import { AddThemeComponent } from './themes/add-theme/add-theme.component';
import { ThemeDetailsComponent } from './themes/theme-details/theme-details.component';
import { WheelComponent } from './wheel/wheel.component';
import { MeloComponent } from './melo/melo.component';
import { GamePickerComponent } from './themes/game-picker/game-picker.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'add-theme', component: AddThemeComponent },
  {
    path: 'k/:key',
    component: ThemeDetailsComponent,
    resolve: { data: themeResolver },
    children: [
      { path: '', component: GamePickerComponent },
      { path: 'wheel', component: WheelComponent },
      { path: 'melo', component: MeloComponent },
    ],
  },
];
